import Message from '@/components/Message';
import Icon from '@/components/Icon/Icon';
import { getNewCollectionPageUrl, getNoteSharedUrl } from '@/utils/urlHelper';
import { noop, stopEvent, formatNumByK } from '@/utils/util';
import Ajax from '@/utils/ajax';
import shareToSNS from '@/utils/share';
import { MenuItem, SubMenu, ShareMenu } from '@/components/Menu/';
import { getState } from '@/reducers/Global/GlobalReducer';
import { User } from '@/constants/actionTypes';
import weiboIcon from '@/assets/images/social_icons/32/weibo.png';
import { setQrCodeModalData, setPublishSuccessData } from '@/actions/GlobalAction';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import i18n from 'react-intl-universal';
import styles from './PublishSuccessModal.scss';
import tpl from './tpl';

const collectionIdAttr = 'data-collection-id';

const postNoteKey = 'publishSuccessModal.post-note';
const postingNoteKey = 'publishSuccessModal.posting-note';
const postedNoteKey = 'publishSuccessModal.posted-note';

const postNoteAttr = 'data-post-text';
const postingNoteAttr = 'data-posting-text';
const postedNoteAttr = 'data-posted-text';

// @withRouter
@connect(
  state => ({
    globalState: getState(state),
  }),
  dispatch => ({
    setPublishSuccessData: (show, data) => dispatch(setPublishSuccessData(show, data)),
    setQrCodeModalData: (show, data) => dispatch(setQrCodeModalData(show, data)),
  }),
)
export default class PublishSuccessModal extends Component {
  constructor(props) {
    super(props);
    const { data: { title, slug } } = this.props;
    this.noteSlug = slug;
    // 分享数据
    this.shareData = {
      link: getNoteSharedUrl(this.noteSlug),
      title,
      text: title,
    };
    // 按页存储
    this.cachEditableCoData = {};
    this.cachLatestCoData = {};
    this.cachRecCoData = {};

    this.state = {
      curEditableCoPageNum: 1, // 当前用户管理专题展示的页码
      totalEditableCoPage: -1,
      curLatestCoPageNum: 1, // 当前用户最近投稿专题展示的页码
      totalLatestCoPage: -1,
      curRecCoPageNum: 1, // 当前用户推荐专题展示的页码
      totalRecCoPage: -1,
      searchResultData: [], // 搜索的结果数据
      qrcdoeModalVisible: false,
      isLoadingRecCo: false, // 正在请求推荐文集
      isLoadingLatestCo: false, // 正在请求最近投稿文集
      isLoadingEditableCo: false, // 正在请求我的文集
      isSearching: false, // 正在请求搜索文集
      hasInputValue: false, // 正在搜索
    };
  }

  componentDidMount() {
    const { data: { paid, noteId, title, slug } } = this.props;
    // 付费文章不需要显示这两个模块
    if (!paid) {
      this.getDataByPage('EditableCo', 1);
      this.getDataByPage('LatestCo', 1);
      this.getDataByPage('RecCo', 1);
    }
    const { shareData } = this;
    // clipboard 可以异步加载（TODO)
    if (!this.clipboard) {
      this.clipboard = new Clipboard(`.${styles['copy-link']}`);
      this.clipboard.on('success', (e) => {
        Message.success(i18n.get('publishSuccessModal.copy-success'));
        e.clearSelection();
      });
      this.clipboard.on('error', (e) => {
        Message.error(i18n.get('publishSuccessModal.copy-fail'));
      });
    }
  }

  contributeToCollection = (collectionId, noteId) => {
    return Ajax.contributeToCollection(collectionId, noteId);
  }
  showBigQrcodeModal = () => {
    const { shareData } = this;
    this.props.setQrCodeModalData(true, { link: shareData.link });
  }

  // 分页请求数据，管理的专题、推荐的专题
  getDataByPage = (name, page) => {
    const perPageSize = name === 'RecCo' ? 30 : 6;
    if (page < 1) {
      return;
    }
    // 最近投稿的专题 需要一个max_id
    let maxId;
    if (name === 'LatestCo') {
      // 前一页数据还没有，是没法获取到后一页数据的，所以直接retrun
      if (page > 1 && !this.cachLatestCoData[page - 1]) {
        return;
      }
      const prePageData = this.cachLatestCoData[page - 1];
      if (prePageData) {
        // 取最后一个submitted_at
        maxId = (prePageData[prePageData.length - 1] || {}).submitted_at;
      }
    }
    const { data: { noteId } } = this.props;
    const data = this[`cach${name}Data`][page];

    this.setState({
      [`cur${name}PageNum`]: page,
    });
    // 优先看缓存
    if (data) {
      this.setState({
        [`isLoading${name}`]: false,
      });
      return;
    }
    // ajax begin
    this.setState({
      [`isLoading${name}`]: true,
    });
    Ajax[`get${name}llections`](noteId, page, perPageSize, { maxId }).then((res) => {
      const resData = res.data;
      let totalPage = 0;
      if (resData.total_pages !== undefined) {
        totalPage = resData.total_pages;
      } else if (resData.total_count !== undefined) {
        totalPage = Math.ceil(resData.total_count / perPageSize);
      }
      // save data
      this.setState({
        [`total${name}Page`]: totalPage,
      });
      this[`cach${name}Data`][page] = res.data.collections;
      // this[`cach${name}Data`][page] = [1, 2, 3, 4, 5, 6];

      // 如果当前展示页和返回的数据页一致，需要去掉loading
      // console.log(this.state[`cur${name}PageNum`], page);
      if (this.state[`cur${name}PageNum`] === page) {
        this.setState({
          [`isLoading${name}`]: false,
        });
      }
    }).catch((error) => {
      // console.log('getDataByPage::', error);
      this.setState({
        [`isLoading${name}`]: false,
      });
      // Message.error(i18n.get('error.try-again'));
    });
  }
  onContributeBtnClick = (e) => {
    const { data: { noteId } } = this.props;
    const { target } = e;
    const collectionId = target.getAttribute(collectionIdAttr);
    const postNoteText = target.getAttribute(postNoteAttr);
    const postingNoteText = target.getAttribute(postingNoteAttr);
    const postedNoteText = target.getAttribute(postedNoteAttr);

    // 防止重复投稿
    if (!collectionId) {
      return;
    }
    target.removeAttribute(collectionIdAttr);
    const nextElem = target.nextElementSibling;
    target.innerHTML = postingNoteText;
    this.contributeToCollection(collectionId, noteId).then((data) => {
      target.innerHTML = postedNoteText;
    }).catch((error) => {
      target.innerHTML = postNoteText;
      target.setAttribute(collectionIdAttr, collectionId);
      Message.error(error.error);
    });
  }

  onCloseClick = () => {
    this.props.setPublishSuccessData(false); // 关闭弹窗
  }
  onWeiboShareBtnClick = () => {
    const { shareData } = this;
    shareToSNS('weibo', shareData.link, shareData.title, shareData.text);
  }
  onWechatShareBtnClick = () => {
    this.showBigQrcodeModal();
  }
  searchCollections = (noteId, queryword) => {
    this.setState({
      isSearching: true,
      searchResultData: [],
    });
    Ajax.searchCollections(noteId, queryword).then((res) => {
      const { data } = res;
      // console.log('searchCollections success::', data);
      this.setState({
        isSearching: false,
        searchResultData: data,
      });
    }).catch((error) => {
      // console.log('searchCollections error::', error);
      this.setState({
        isSearching: false,
        searchResultData: [],
      });
    });
  }
  onSearchInputChange = (e) => {
    const { data: { noteId } } = this.props;
    const value = (e.target.value || '').trim();
    const { isSearching } = this.state;
    clearTimeout(this.searchTimer);
    if (!value) {
      this.setState({
        hasInputValue: false,
        searchResultData: [],
      });
      return;
    }
    if (isSearching) {
      return;
    }
    this.searchTimer = setTimeout(() => {
      this.setState({
        hasInputValue: true,
      });
      this.searchCollections(noteId, value);
    }, 500);
  }
  // 获取当前所有的RecCo data
  getCurRecCoData = () => {
    const { cachRecCoData } = this;
    const { curRecCoPageNum } = this.state;
    let result = [];
    for (let i = 1; i <= curRecCoPageNum; i++) {
      result = result.concat(cachRecCoData[i] || []);
    }
    return result;
  }
  renderNormalPage = () => {
    const {
      cachEditableCoData,
      cachLatestCoData,
      cachRecCoData,
    } = this;
    const {
      isLoadingEditableCo,
      isLoadingLatestCo,
      isLoadingRecCo,
      curEditableCoPageNum,
      totalEditableCoPage,
      curLatestCoPageNum,
      totalLatestCoPage,
      curRecCoPageNum,
      totalRecCoPage,
    } = this.state;
    const { data: { noteId, title, slug } } = this.props;
    return (
      <div className={styles['normal-page']}>
        {
          // 我管理的专题模块
          cachEditableCoData[curEditableCoPageNum] && tpl.renderEditableCoPage(
            cachEditableCoData[curEditableCoPageNum],
            isLoadingEditableCo,
            styles,
            {
              postText: i18n.get('publishSuccessModal.include-note'),
              postingText: i18n.get('publishSuccessModal.including-note'),
              postedText: i18n.get('publishSuccessModal.included-note'),
            },
            this.onContributeBtnClick,
            curEditableCoPageNum,
            totalEditableCoPage,
            () => {
              this.getDataByPage('EditableCo', curEditableCoPageNum - 1);
            },
            () => {
              this.getDataByPage('EditableCo', curEditableCoPageNum + 1);
            },
            getNewCollectionPageUrl(),
          )
        }
        {
          // 最近投稿模块
          tpl.renderLatestCoPage(
            cachLatestCoData,
            isLoadingLatestCo,
            styles,
            {
              postText: i18n.get(postNoteKey),
              postingText: i18n.get(postingNoteKey),
              postedText: i18n.get(postedNoteKey),
            },
            this.onContributeBtnClick,
            curLatestCoPageNum,
            totalLatestCoPage,
            () => {
              this.getDataByPage('LatestCo', curLatestCoPageNum - 1);
            },
            () => {
              this.getDataByPage('LatestCo', curLatestCoPageNum + 1);
            },
          )
        }
        {
          // 推荐专题模块
          tpl.renderRecCoPage(
            this.getCurRecCoData(),
            isLoadingRecCo,
            styles,
            {
              postText: i18n.get(postNoteKey),
              postingText: i18n.get(postingNoteKey),
              postedText: i18n.get(postedNoteKey),
            },
            this.onContributeBtnClick,
            curRecCoPageNum,
            totalRecCoPage,
            () => {
              this.getDataByPage('RecCo', curRecCoPageNum + 1);
            },
          )
        }
      </div>
    );
  }
  renderSearchResultPage = () => {
    const {
      isSearching,
      searchResultData,
    } = this.state;

    return (
      <div className={styles['search-result-page']}>
        <div className={styles['collection-auto-page']}>
          {
            tpl.renderRecomendCollectionItems(
              searchResultData,
              isSearching,
              styles,
              {
                postText: i18n.get(postNoteKey),
                postingText: i18n.get(postingNoteKey),
                postedText: i18n.get(postedNoteKey),
              },
              this.onContributeBtnClick,
            )
          }
        </div>
      </div>
    );
  }

  render() {
    const { shareData, noteSlug } = this;
    const { data: { paid } } = this.props;
    const {
      qrcdoeModalVisible,
      isSearching,
      hasInputValue,
    } = this.state;
    const modalTopClasses = classNames(styles['modal--top'], {
      [styles['modal-top-middle']]: paid,
    });
    return (
      <div className={styles['success-modal']}>
        <div className={modalTopClasses}>
          <div className={styles['title-wrap']}>
            <a href={shareData.link} className={styles['title']}>
              {shareData.title}
            </a>
            <br/>
            <a href={shareData.link} className={styles['status-des']}>
              {i18n.get('publishSuccessModal.success-des')}
            </a>
          </div>
          {
            tpl.renderShareItems(
              shareData,
              styles,
              { weiboIcon },
              this.onWeiboShareBtnClick,
              this.onWechatShareBtnClick,
            )
          }
        </div>
        <div className={styles['close-btn']} onClick={this.onCloseClick}>×</div>
        <div className={styles['modal--rec']}/>
        {
          !paid &&
          <div className={styles['modal--bottom']}>
            <div className={styles['collection-des']}>
              <div className={styles['search-input-wrap']}>
                <Icon name='search' size='2x'/>
                <input
                  type="text"
                  placeholder={i18n.get('publishSuccessModal.search-collection')}
                  onChange={this.onSearchInputChange}
                />
              </div>
              <div className={styles['des']}>{i18n.get('publishSuccessModal.post-des')}</div>
            </div>
            {
              hasInputValue && this.renderSearchResultPage()
            }
            {
              !hasInputValue && this.renderNormalPage()
            }
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PublishSuccessModal/PublishSuccessModal.js